import { useMemo } from 'react';

import { keyOf, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn, duplicateAction, editAction, defaultColumnId, extraActions, defaultActiveColumn } from '@Components/Grid/utils/column';

import CostModeFormatter from './CostModeFormatter';
import CostUpdater from './CostUpdater';
import DefaultToggle from './DefaultToggle';
import DeleteEntity from './DeleteEntity';
import Generator from './Generator';
import PayoutFormatter from './PayoutFormatter';
import PublisherLinkFormatter from './PublisherLinkFormatter';
import ThrottlingFormatter from './ThrottlingFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    column.accessor('description', {
      header: 'Description',
      cell: info => <NameAndCreateDateFormatter info={info} />,
      size: 300,
    }),
    column.accessor('publisher_id', {
      header: 'Publisher',
      cell: info => <PublisherLinkFormatter info={info} />,
    }),
    column.accessor('cost_mode', {
      header: 'Cost Mode',
      cell: info => <CostModeFormatter info={info} />,
    }),
    column.accessor('payout', {
      header: 'Payout',
      cell: info => <PayoutFormatter info={info} />,
    }),
    column.accessor('scrub_percent', {
      header: 'Throttling Method',
      cell: info => <ThrottlingFormatter info={info} />,
      enableSorting: false,
    }),
    defaultColumn('default', 'Default', defaultToggleFormatter),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction,
      extraActions(
        duplicateAction,
        generatorAction,
        costUpdaterAction,
      )),
  ], [])
}

function defaultToggleFormatter(info) {
  return <DefaultToggle key={keyOf(info)} info={info} />
}

function deleteAction(info) {
  return <DeleteEntity key={keyOf(info, 'delete')} info={info} />
}

function generatorAction(info) {
  return <Generator key={keyOf(info, 'generator')} info={info} />
}

function costUpdaterAction(info) {
  return <CostUpdater key={keyOf(info, 'cost-updater')} info={info} />
}
